var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clip"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,300 H 300 V 0 H 0 Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.3333333,0,0,-1.3333333,0,400)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(205.3541,101.7101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 6.578,3.1 12.83,6.76 18.749,10.873 V 84.126 C 12.83,88.239 6.578,91.9 0,95 Z",
    fill: "#00c18f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(205.3541,101.7101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 6.578,3.1 12.83,6.76 18.749,10.873 V 84.126 C 12.83,88.239 6.578,91.9 0,95 Z",
    fill: "#00c18f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(71.7615,115.5581)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 5.88,-4.436 12.153,-8.365 18.749,-11.766 V 79.07 C 12.153,75.668 5.88,71.74 0,67.304 Z",
    fill: "#ff5163"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(205.3541,101.7101)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 6.578,3.1 12.83,6.76 18.749,10.873 V 84.126 C 12.83,88.239 6.578,91.9 0,95 Z",
    fill: "#00c18f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(169.9304,90.9273)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 6.417,0.988 12.677,2.437 18.749,4.327 V 112.238 C 12.677,114.128 6.417,115.577 0,116.565 Z",
    fill: "#ff5163"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.4845,97.6022)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C 6.053,-2.264 12.307,-4.106 18.749,-5.455 V 108.671 C 12.307,107.322 6.053,105.479 0,103.215 Z",
    fill: "#00c18f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(57.7873,170.6479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0,0 C -6.481,-6.517 -12.319,-13.674 -17.314,-21.438 -12.319,-29.202 -6.481,-36.359 0,-42.876 Z",
    fill: "#00c18f"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(240.7777,172.0826)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 v -45.745 c 7.065,6.888 13.386,14.537 18.749,22.872 C 13.386,-14.537 7.065,-6.889 0,0",
    fill: "#ff5163"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(155.9561,208.88)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 0,0 c -1.979,0.089 -3.955,0.193 -5.956,0.193 -4.324,0 -8.578,-0.278 -12.793,-0.69 V -28.65 H 0 Z",
    fill: "#ff5163"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a49b27881f6ca28b5afdf9d533e624f7.svg";
export { ForwardRef as ReactComponent };